import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" {...props}><rect width="24" height="2" x="4" y="15" fill="currentColor" rx="1" /><rect width="24" height="2" x="4" y="7" fill="currentColor" rx="1" /><rect width="24" height="2" x="4" y="23" fill="currentColor" rx="1" /></svg>);